import Destination from './Destination'

export default Destination
